const groupResultsByContinent = (results) => {
    const grouped = results.reduce((objectsByKeyValue, result) => {
        const { continent } = result;

        return {
            ...objectsByKeyValue,
            [continent]: (objectsByKeyValue[continent] || []).concat(result),
        };
    }, {});

    return Object.keys(grouped).reduce((map, key) => map.set(key, grouped[key]), new Map());
};

export { groupResultsByContinent };
